import { useAction } from 'next-safe-action/hooks'

import {
  updateContractMmpEventsSentLog as _updateContractMmpEventsSentLog,
  TUpdateContractMmpEventsSentLogRequest,
} from '@/entities/contract'
import { useServerErrorHandler } from '@/shared/config'

type Props = {
  onSuccess?: () => void
}

export const useUpdateContractMmpEventsSentLog = ({
  onSuccess,
}: Props = {}) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(_updateContractMmpEventsSentLog, {
    onSuccess,
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const updateContractMmpEventsSentLog = (
    params: TUpdateContractMmpEventsSentLogRequest,
  ) => {
    action.execute(params)
  }

  return {
    updateContractMmpEventsSentLog,
  }
}
